/*
 *  Product Template Scripts
 *    Scripts that are only meant to run on the Product Template.
 *
 *  Version:
 *    2.0.0 - 2019/05/02
 */

import './../sections/product-carousel/ProductCarousel';
import './../sections/international-message/InternationalMessage';

// import './../sections/product-description/ProductDescription';
// import './../sections/product-lifestyle/ProductLifestyle';
import './../sections/product-sold-out-notify/ProductSoldOutNotify';
import './../sections/product-waitlist-notify/ProductWaitlistNotify';
// import './../sections/product-specifications/ProductSpecifications';
// // import './../sections/recommended-products/RecommendedProducts';
// import './../sections/product-style/ProductStyle';
// import './../sections/recently-viewed/RecentlyViewed';

import { Swatch, SWATCH_CONTAINER_SELECTOR, ON_VARIANT_CHANGE } from './../objects/swatch/Swatch';
import { ProductTemplateQuantitySelector } from './../objects/product/ProductTemplateQuantitySelector';
import { PillowInsertUpsell, pillowInsertGetState } from '../sections/product-pillow-insert/PillowInsertUpsell';
import { AddToCartButton } from './../objects/product/AddToCartButton';
import { printMoney, getCountOfVariantInCart } from '@process-creative/slate-theme-tools';
// import { TierProgressBar } from '../objects/progress-bar/TierProgressBar';
import { DiscountMessaging } from './../sections/discount-messaging/DiscountMessaging';
import { fetchGeo, onGeoFetch, addInternationalMsgClass } from './../tools/Geo';
import { initialiseWishlist } from './../tools/Wishlist';

//Selectors
export const PRODUCT_TEMPLATE_CONTAINER = '[data-product-template]';
export const PRODUCT_DETAILS_CONTAINER = '[data-product-template-details]';
export const PRODUCT_DETAILS_SCROLL_SELECTOR = '[data-product-details-scroll]';
export const PRODUCT_SHOWROOM_SCROLL_SELECTOR = '[data-product-showroom-scroll]';
export const PRODUCT_REVIEW_SCROLL_SELECTOR = '[data-product-review-scroll]';
export const HEADER_CONTAINER = '[data-header-container]';
export const PRODUCT_DESCRIPTION_SELECTOR = '[data-product-description]';
export const PRODUCT_SHOWROOM_SELECTOR = '[data-showroom]';
export const PRODUCT_ADD = '[data-product-template-add-to-cart]';
export const PRODUCT_BUY_NOW_BUTTON = '[data-product-template-add-scroll]';
export const PRODUCT_STICKY_ADD_CONTAINER = '[data-product-sticky-add]';
export const PRODUCT_STICKY_ADD_TOP = '[data-product-sticky-add-top]';
export const PRODUCT_MONEY = '[data-product-money]';
export const PRODUCT_COMPARE_MONEY = '[data-product-compare-money]';
export const PRODUCT_ALTERNATE_PAYMENT_MONEY = '[data-alternate-payment-price]';
export const SWATCH_SHOWMORE_BUTTON = '[data-swatches-showmore-btn]';
export const PRODUCT_JSON = '[data-product-json]';
export const PRODUCT_DISCOUNT = '[data-product-template-discount]';
const SELECTOR_MATTRESS_SIZE = '[data-product-mattress-size]';
const SELECTOR_MATTRESS_DIMENSIONS = '[data-product-size-dimensions]';

export const CLASS_VISIBLE = 'is-visible';
export const CLASS_EXPEND_SWATCHES = 'is-expanding';
export const CLASS_SAVED = 'is-saved';
export const CLASS_ACTIVE = 'is-active';

export const PRODUCT_LOW_STOCK = '[data-product-low-stock]';

export const WAITLIST_SELECTOR = '[data-product-template-waitlist]';
export const WAITLIST_ETA = '[data-product-template-waitlist-date]';
export const BACK_IN_STOCK_FORM = '[data-sold-out-notify]';
export const BACK_IN_STOCK_FORM_WRAPPER = '[data-sold-out-notify-wrapper]';

export const WISHLIST_BUTTON_SELECTOR = '[data-product-template-wishlist]';


class ProductTemplate {
  constructor(container) {
    //Elements
    this.container = container;
    this.wishlistButtons = container.find(WISHLIST_BUTTON_SELECTOR);

    //Setup Product Swatches Widget, Quantity and Add to cart
    this.pillowInsert = PillowInsertUpsell({ template: document.querySelectorAll('.c-section__product-pillow-insert') })
    this.swatches = new Swatch(this.container);
    this.quantitySelector = new ProductTemplateQuantitySelector(this, this.container);
    this.addToCart = new AddToCartButton(this, this.container.find(PRODUCT_ADD));

    //Header, used for calculating height
    this.headerInner = $(HEADER_CONTAINER);

    //Elements
    this.productDetails = container.find(PRODUCT_DETAILS_CONTAINER);
    this.productAddToCartButton = container.find(PRODUCT_ADD);
    this.stickyAddContainer = container.find(PRODUCT_STICKY_ADD_CONTAINER);
    this.discountMessageContainer = container.find(PRODUCT_DISCOUNT);
    this.mattressSizeElement = container.find(SELECTOR_MATTRESS_SIZE);
    this.mattressSizeSpan = container.find(SELECTOR_MATTRESS_DIMENSIONS);

    //Colour swatches
    this.colourSwatchesContainer = this.productDetails.find('[data-swatch-group]').first();
    this.colourSwatches = this.colourSwatchesContainer.find('[data-swatch-object]');
    this.swatchShowmoreBtn = this.productDetails.find(SWATCH_SHOWMORE_BUTTON);
    if (this.colourSwatches.length > 5) this.swatchShowmoreBtn.text(`+ ${this.colourSwatches.length - 5} more`);
    this.timeout = 0;

    container.on('click touchend', PRODUCT_DETAILS_SCROLL_SELECTOR, (e) => this.onScrollToDetails(e));
    container.on('click touchend', PRODUCT_SHOWROOM_SCROLL_SELECTOR, (e) => this.onScrollToShowroom(e));
    container.on('click touchend', PRODUCT_REVIEW_SCROLL_SELECTOR, (e) => this.onScrollToReview(e));
    container.on('click touchend', PRODUCT_BUY_NOW_BUTTON, (e) => this.onBuyNow(e));
    container.on('click touchend', PRODUCT_STICKY_ADD_TOP, (e) => this.scrollToTop(e));
    container.on('click touchend', SWATCH_SHOWMORE_BUTTON, e => this.showMoreColourSwatches(e));

    this.onScroll();
    $(window).on('scroll', () => setTimeout(this.onScroll(), 50));

    $(document).on(ON_VARIANT_CHANGE, (e,variant) => this.onVariantChanged(variant));

    // On init check the stock levels for low stock
    this.checkLowStock();
    this.checkifWaitlistOrSoldOut(this.getVariantData());

    // this.tierProgressBar = new TierProgressBar(this.container);

    let collections = JSON.parse(container.find(PRODUCT_JSON).html()).collections;
    DiscountMessaging(collections, this.discountMessageContainer);

    //look up geo
    let geoCountry = fetchGeo(data => onGeoFetch(data));
    addInternationalMsgClass(geoCountry);

    //remove showroom link if there is no showroom section
    if ($('[data-showroom]').length == 0) container.find(PRODUCT_SHOWROOM_SCROLL_SELECTOR).hide();

    //wishlist
    $(document).on('window.swymPageLoad', initialiseWishlist());

  }

  getExtraVariantsToAdd() {
    return [
      ...pillowInsertGetState(this.pillowInsert)
    ];
  }

  onScroll() {
    let scrollTop = $(window).scrollTop(); //Pixels hidden above current screen
    let elemTop = this.productAddToCartButton.offset().top; //Distance from elements to top

    //Have we reached bottom of elem?
    if(scrollTop < elemTop) {
      this.stickyAddContainer.removeClass(CLASS_VISIBLE);
      $('body').removeClass('has-sticky-atc');
      $('[data-header-container]').removeClass('is-sticky-add-visible')
      return;
    }

    this.stickyAddContainer.addClass(CLASS_VISIBLE);
    $('body').addClass('has-sticky-atc');
    $('[data-header-container]').addClass('is-sticky-add-visible')
  }

  onScrollToDetails(e) {
    e.preventDefault();
    e.stopPropagation();

    let headerHeight = this.headerInner.outerHeight();
    if ($(PRODUCT_DESCRIPTION_SELECTOR).length == 0) return;
    $(PRODUCT_SHOWROOM_SCROLL_SELECTOR).removeClass(CLASS_ACTIVE);
    $(PRODUCT_REVIEW_SCROLL_SELECTOR).removeClass(CLASS_ACTIVE);
    $(PRODUCT_DETAILS_SCROLL_SELECTOR).removeClass(CLASS_ACTIVE);

    $('html,body').animate({
      scrollTop: $(PRODUCT_DESCRIPTION_SELECTOR).offset().top - headerHeight
    },'slow');
    $(e.currentTarget).addClass(CLASS_ACTIVE);
  }

  onScrollToShowroom(e) {
    e.preventDefault();
    e.stopPropagation();

    let headerHeight = this.headerInner.outerHeight();
    if ($(PRODUCT_SHOWROOM_SELECTOR).length == 0) return;
    $(PRODUCT_SHOWROOM_SCROLL_SELECTOR).removeClass(CLASS_ACTIVE);
    $(PRODUCT_REVIEW_SCROLL_SELECTOR).removeClass(CLASS_ACTIVE);
    $(PRODUCT_DETAILS_SCROLL_SELECTOR).removeClass(CLASS_ACTIVE)

    $('html,body').animate({
      scrollTop: $(PRODUCT_SHOWROOM_SELECTOR).offset().top - headerHeight
    },'slow');
    $(e.currentTarget).addClass(CLASS_ACTIVE);
  }

  onScrollToReview(e) {
    e.preventDefault();
    e.stopPropagation();

    let headerHeight = this.headerInner.outerHeight();
    if ($(PRODUCT_REVIEW_SCROLL_SELECTOR).length == 0) return;
    $(PRODUCT_SHOWROOM_SCROLL_SELECTOR).removeClass(CLASS_ACTIVE);
    $(PRODUCT_REVIEW_SCROLL_SELECTOR).removeClass(CLASS_ACTIVE);
    $(PRODUCT_DETAILS_SCROLL_SELECTOR).removeClass(CLASS_ACTIVE)

    $('html,body').animate({
      scrollTop: $('[data-oke-reviews-widget-holder]').offset().top - headerHeight
    },'slow');
    $(e.currentTarget).addClass(CLASS_ACTIVE);
  }

  onBuyNow(e) {
    e.preventDefault();
    e.stopPropagation();

    let headerHeight = this.headerInner.outerHeight();
    headerHeight = headerHeight * 1.5;

    $('html,body').animate({
      scrollTop: this.productDetails.offset().top - headerHeight
    },'slow');
  }

  // Called when the variant selector / swatches changes the variant
  onVariantChanged(variant) {
    let { price, compare_at_price, id } = variant;

    //Adjust Price Display
    let money = this.container.find(PRODUCT_MONEY);
    let alternateMoney = this.container.find(PRODUCT_ALTERNATE_PAYMENT_MONEY);
    if(!price || price <= 0) {
      money.removeAttr('data-money');//Stops any currency converters attempting to convert.
      money.html('FREE');//TODO: Make this not hard coded.
    } else {
      money.attr('data-money', price);
      money.html(printMoney(price));
      alternateMoney.html(printMoney(price / 4, 'money_format'));
    }

    //Adjust compare price display
    let compare = this.container.find(PRODUCT_COMPARE_MONEY);
    if(!compare_at_price || compare_at_price <= price) {
      compare.removeAttr('data-money');
      compare.html('');
    } else {
      compare.attr('data-money', compare_at_price);
      let saving = compare_at_price - price;
      let x = `${Language.strings['products.product.save']} ${printMoney(saving)}!`;
      compare.html(x);
    }

    this.checkifWaitlistOrSoldOut(variant);
    this.updateWishlist(id);
    this.updateSize(variant);
  }

  // Gets variant title, 
  // then gets the mattress size from the data attributes
  // then injects into the size element
  updateSize({ title }){
    const sizeTitle = title.split('/ ')[1].toLowerCase().trim().replace(' ', '-');
    const mattressSize = this.mattressSizeElement.attr('data-size-' + sizeTitle);
    this.mattressSizeSpan.html(mattressSize);
  }

  //check if its available, if it's not, show the sold out notify
  checkifWaitlistOrSoldOut(variant) {
    let eta = variant.waitlist_eta;
    let etaHTML = `
      <p>
        <span> ${Language.strings['waitlist_notify.waitlist_arriving_message']} </span>
        <span data-product-template-waitlist-date>
          ${eta}
        </span>
      </p>`;
    //upadte the varaint ID
    this.container.find(BACK_IN_STOCK_FORM+' [name="variant"]').val(variant.id);

    if (!variant.available) {
      this.container.removeClass('has-sold-out-notify has-waitlist-notify');
      this.container.find('[data-sold-out-notify]').removeClass('is-hidden');
      this.container.find('[data-waitlist-notify]').removeClass('is-hidden');
      this.container.find('[data-notify-error]').removeClass('is-active');

      if (eta) {
        //if its has a waitlist date
        this.container.addClass('has-waitlist-notify');
        this.container.find(WAITLIST_SELECTOR).html(etaHTML);
      } else {
        this.container.removeClass('has-sold-out-notify has-waitlist-notify');
        this.container.addClass('has-sold-out-notify');
      }
        this.container.find('[data-notify-message-default]').addClass('is-active');
        this.container.find('[data-notify-message-success]').removeClass('is-active');
    } else if (variant.inventory_management == 'shopify' && variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0) {
      //if preorder
      this.container.addClass('is-preorder');

      //if has a preorder/waitlist date
      if (eta) this.container.find(WAITLIST_SELECTOR).html(etaHTML);

      //enable waitlist concurrently with preorder
      this.container.addClass('has-waitlist-notify');
      this.container.find('[data-sold-out-notify]').removeClass('is-hidden');
      this.container.find('[data-waitlist-notify]').removeClass('is-hidden');
      this.container.find('[data-notify-error]').removeClass('is-active');
    } else {
      this.container.removeClass('has-sold-out-notify has-waitlist-notify is-preorder');
    }

  }

  getVariantData() {
    let vs = (this.swatches || this.variantSelector);
    return vs.getVariantData();
  }

  checkLowStock() {
    let product = this.getVariantData();
    if (!!product.available) {
      let totalQty = product.inventory_quantity,
          totalInCart = getCountOfVariantInCart(product.id),
          availableQty = totalQty - totalInCart;
      if (availableQty <= 20 && availableQty > 0) {
        $(PRODUCT_LOW_STOCK).show();
      }
      else if (availableQty == 0 || availableQty > 20) {
        $(PRODUCT_LOW_STOCK).hide();
      }
    }
  }

  scrollToTop(e) {
    e.preventDefault();
    e.stopPropagation();

    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  checkIfDiscount() {
    //Discount message display logic
    let discountJson = JSON.parse($('[data-discount-json]').html());
    discountJson.forEach(discount => {
      if (!discount.collections.length) return this.discountMessageContainer.html(discount.productMessage);
      let discountCollections = discount.collections.split(', ');
      let collectionHandles = this.discountMessageContainer.attr('data-collections').split('|');
      collectionHandles.forEach(collectionHandle => {
        discountCollections.forEach(discountCollection => {
          if (collectionHandle != discountCollection) return;
          this.discountMessageContainer.html(discount.productMessage);
        });
      });
    });
  }

  showMoreColourSwatches(e) {
    e.preventDefault(), e.stopPropagation();
    let self = $(e.currentTarget);
    self.css('display', 'none');
    this.colourSwatches.each((i, el) => {
      setTimeout(() => $(el).addClass('is-show-more'), this.timeout);
      this.timeout += 50;
    });
  }

  //Wishlist
  updateWishlist(id) {
    let wishlistButtons = this.container.find(WISHLIST_BUTTON_SELECTOR);
    //Update the wishlist app if it's ready
    if(SwymProductVariants[id] && wishlistButtons.length){ // current selected variant
      SwymPageData = $.extend({}, SwymPageData,SwymProductVariants[id]);
      SwymPageData.variants = JSON.stringify(SwymPageData.variants);
      if(window.triggerSwymVariantEvent){
        window.triggerSwymVariantEvent(id);
      }
      //Fetch current wishlist products and update wishlist button if necessary
      if(!window.SwymCallbacks) { window.SwymCallbacks = []; }
      window.SwymCallbacks.push(function () {
        _swat.fetchWrtEventTypeET(function (products) {
          let inWishlist = products.some((p) => p.epi == id);
          if(inWishlist) {
            wishlistButtons.addClass(CLASS_SAVED);
            wishlistButtons.attr('disabled', 'disabled');
          } else {
            wishlistButtons.removeClass(CLASS_SAVED);
            wishlistButtons.removeAttr('disabled', 'disabled');
          }
        });
      });
    }
  }
}

$(document).ready(() => {
  //wait for insert section to load
  setTimeout(() => {
    $(PRODUCT_TEMPLATE_CONTAINER).each( (e,i) => new ProductTemplate($(i)) )
  }, 500);
});
